export const styles = (theme) => ({
  blockWrapper: {
    marginTop: -37,
    [theme.breakpoints.down('md')]: {
      marginTop: 0,
    },
  },
});
